import styles from './stickyHeader.module.scss'

import React, { useEffect, useState } from 'react'

import ClassNames from 'classnames'

import Panel from 'Atoms/Panel'

const StickyHeader = ({ triggerId, children }) => {
  const [isVisible, setVisibility] = useState(false)

  const handleScroll = (entries) => {
    if (!window) {
      return null
    }

    var triggerElement = document.getElementById(triggerId)

    if (!triggerElement) {
      return null
    }

    const elementBoundingBox = entries ? entries[0]?.boundingClientRect : null

    if (!elementBoundingBox) {
      return null
    }

    var elementDistanceFromTopOfPage = elementBoundingBox.top

    if (elementDistanceFromTopOfPage < 0) {
      // negative means the top of the element is "above" the viewport (and offscreen)
      setVisibility(true)
    } else {
      setVisibility(false)
    }
  }

  useEffect(() => {
    if (!IntersectionObserver) {
      return
    }

    handleScroll()
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 1], // trigger on show and hide
    }
    const observer = new IntersectionObserver((entries) => {
      handleScroll(entries)
    }, options)

    const elementToObserve = document.getElementById(triggerId)
    if (elementToObserve) {
      observer.observe(elementToObserve)
    } else {
      console.error(`No element to observe was found, did you set triggerId? '${triggerId}'`)
    }
    return () => observer.disconnect()
  }, [triggerId])

  // useEffect(() => {
  //   const handleScrollWrapped = () => {
  //     if(!window.DISABLE_STICKY_SCROLL){
  //       handleScroll()
  //     }
  //   }
  //   window.addEventListener('scroll', handleScrollWrapped, { passive: true });

  //   return () => {
  //     window.removeEventListener('scroll', handleScrollWrapped);
  //   };
  // }, []);

  return (
    <Panel className={ClassNames(styles.sticky_header, isVisible && styles.sticky_header_visible)}>
      {isVisible ? children : false}
    </Panel>
  )
}

export default StickyHeader
